import { TagEventsEnum } from 'common/enums/TagEventsEnum'
import BaseBridge from 'config/bridge/BaseBridge'

export const analyticsCapTorcedor = (screen: string) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen,
    ref_type: 'banner',
    content_name: 'cross cap torcedor',
    action_id: 'entrar em campo',
    product: 'sortezinha prateleira',
    flow: 'prateleira',
  })
}
